import { useEffect } from "react"
import { type AsyncProviderConfig, useLDClient } from "launchdarkly-react-client-sdk"
import { useAuth } from "@/modules/auth/store"
import { useCosmos } from "@/modules/cosmos/stores/use-cosmos-store"

export const launchdarklyConfig: AsyncProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID,
  options: {
    logger:
      import.meta.env.MODE === "development"
        ? console
        : {
            debug: () => {},
            info: () => {},
            warn: () => {},
            error: () => {},
          },
  },
}

export default function LaunchDarklyContextProvider() {
  const { user } = useAuth()
  const { cosmosKey } = useCosmos()
  const ldClient = useLDClient()

  useEffect(() => {
    if (!user?.id || !ldClient || !cosmosKey) return

    const context = {
      kind: "user",
      key: user.id,
      ...user,
      cosmos: cosmosKey,
    }

    ldClient.identify(context)
  }, [user, ldClient, cosmosKey])

  return null
}
